import gql from 'graphql-tag';

export const DEAL_LISTING_ACTIVITY_FRAGMENT = gql`
  fragment DealListingEventActivityFields on CalendarEventViewModel {
    id
    allDay
    subject
    priority
    eventType
    description
    activityStatus
    owner {
      id
      fullName
    }
    account {
      id
      name
    }

    participants {
      id
      fullName
      participationType
      account {
        id
        name
      }
    }

    due {
      dueAt
      isOverdue
      secondsSinceDue
      secondsUntilDue
    }
  }
`;
